<app-modal001 *ngIf="slug === '001'" [closeModalSearch]="closeModalSearch" [typeModal]="typeModal">
	<ng-content select="[content]" content></ng-content>
</app-modal001>
